<template>
  <div class="patient-requests-form" dir="rtl">
    <fieldset v-if="categoriesEnabled">
      <legend>סוג הבקשה</legend>

      <div class="patient-request-options">
        <div
          v-for="option in options"
          :key="option.value"
          class="form_check form_check-black patient-request-option"
        >
          <label>
            <input
              type="checkbox"
              :value="option.value"
              :checked="value.types.includes(option.value)"
              @change="toggleType(option.value)"
            />
            {{ option.text }}
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </fieldset>

    <div class="patient-request-notes">
      <label for="patient-request-notes">{{ notesLabel }}</label>
      <textarea
        id="patient-request-notes"
        :value="value.notes"
        :placeholder="notesPlaceholder"
        maxlength="1000"
        @input="updateNotes($event.target.value)"
      ></textarea>
    </div>
  </div>
</template>

<script>
import {
  getPatientRequestNotesLabel,
  getPatientRequestNotesPlaceholder,
  PATIENT_REQUEST_CATEGORIES_ENABLED,
  PATIENT_REQUEST_OPTIONS
} from "@/utilities/patient-requests";

export default {
  name: "PatientRequestsForm",
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: PATIENT_REQUEST_OPTIONS,
      categoriesEnabled: PATIENT_REQUEST_CATEGORIES_ENABLED
    };
  },
  computed: {
    notesLabel() {
      return getPatientRequestNotesLabel(this.value.types);
    },
    notesPlaceholder() {
      return getPatientRequestNotesPlaceholder(this.value.types);
    }
  },
  methods: {
    toggleType(type) {
      if (!PATIENT_REQUEST_CATEGORIES_ENABLED) return;

      const types = [...this.value.types];
      const index = types.indexOf(type);

      if (index === -1) {
        types.push(type);
      } else {
        types.splice(index, 1);
      }

      this.$emit("input", { types, notes: this.value.notes });
    },
    updateNotes(notes) {
      this.$emit("input", {
        types: PATIENT_REQUEST_CATEGORIES_ENABLED ? [...this.value.types] : [],
        notes
      });
    }
  }
};
</script>

<style scoped>
.patient-requests-form {
  text-align: right;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

legend {
  color: #222;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 8px;
}

.patient-requests-hint {
  color: #606060;
  font-size: 20px;
  line-height: 1.5;
  margin: 0 0 24px;
}

.patient-request-options {
  display: flex;
  flex-wrap: wrap;
  gap: 18px 36px;
}

.patient-request-option {
  font-size: 22px;
  margin: 0;
  min-width: 120px;
}

.patient-request-notes {
  margin-top: 30px;
}

.patient-request-notes label {
  display: block;
  font-size: 20px;
  margin-bottom: 10px;
}

.patient-request-notes textarea {
  border: 1px solid #b9b9b9;
  border-radius: 3px;
  box-sizing: border-box;
  min-height: 120px;
  padding: 12px;
  resize: vertical;
  width: 100%;
}

@media only screen and (max-width: 800px) {
  legend {
    font-size: 23px;
  }

  .patient-requests-hint {
    font-size: 18px;
  }

  .patient-request-option {
    font-size: 20px;
  }

  .patient-request-options {
    flex-direction: column;
    gap: 16px;
  }
}
</style>
